<template>
  <v-card>
    <v-card-title class="section-title pt-6 pb-2 mb-0">
      <span>Configurações dos Atributos Dinâmicos</span>
      <v-spacer />
      <configure-dynamic-attribute ref="addDialog" :is-new="true" :save-dynamic-attribute-fn="saveDynamicAttribute" />
      <configure-dynamic-attribute ref="editDialog" :is-new="false" :save-dynamic-attribute-fn="saveDynamicAttribute" />
    </v-card-title>
    <v-card-text>
      Atributos dinâmicos serão exibidos no cadastro de consumidores via aplicativo e no hotsite, conforme configuração. Estes atributos podem então ser
      utilizados na segmentação. Atributos importados de outras fontes não podem ser editados, apenas em contato com o suporte.
      <paginated-data-table ref="table" :headers="headers" :query="query" query-name="dynamicAttributes" query-main-property-name="dynamicAttributes">
        <template #item.label="{ item }">
          {{ item.label }}
        </template>
        <template #item.attribute="{ item }">
          {{ item.attribute }}
        </template>
        <template #item.type="{ item }">
          {{ getTypeLabel(item.type) }}
        </template>
        <template #item.origin="{ item }">
          {{ getOriginLabel(item.origin) }}
        </template>
        <template #item.available_on_app="{ item }">
          <mf-icon :icon="item.available_on_app ? 'check_circle' : 'cancel'" :color="item.available_on_app ? 'verde-l20' : 'vermelho-l20'" size="sm" />
        </template>
        <template #item.available_on_hotsite="{ item }">
          <mf-icon :icon="item.available_on_hotsite ? 'check_circle' : 'cancel'" :color="item.available_on_hotsite ? 'verde-l20' : 'vermelho-l20'" size="sm" />
        </template>
        <template #item.menu="{ item }">
          <v-menu bottom origin="center center" transition="scale-transition">
            <template v-slot:activator="{ on }">
              <mf-button type="icon" icon="more_vert" color="cinza-0" v-on:click.native="on.click" />
            </template>
            <v-list>
              <v-list-item :disabled="!isDynamicAttributeEditable(item)" @click="goToDynamicAttribute(item)">
                <v-list-item-title>Editar</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </paginated-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { LIST_DYNAMIC_ATTRIBUTES, UPSERT_DYNAMIC_ATTRIBUTE } from '@/modules/configuracoes/site-de-cadastramento/graphql'
import {
  DYNAMIC_ATTRIBUTE_TYPES,
  DYNAMIC_ATTRIBUTE_ORIGINS,
  isDynamicAttributeEditable,
} from '@/modules/configuracoes/site-de-cadastramento/constants/dynamicAttributes'

export default {
  name: 'DynamicAttributesTable',
  components: {
    PaginatedDataTable: () => import('@/components/PaginatedDataTable.vue'),
    ConfigureDynamicAttribute: () => import('@/modules/configuracoes/site-de-cadastramento/views/components/ConfigureDynamicAttribute.vue'),
  },
  data: () => ({
    headers: [
      {
        text: 'Label',
        value: 'label',
      },
      {
        text: 'Nome do atributo',
        value: 'attribute',
      },
      {
        text: 'Tipo',
        value: 'type',
      },
      {
        text: 'Origem',
        value: 'origin',
      },
      {
        text: 'Disponível no App',
        value: 'available_on_app',
      },
      {
        text: 'Disponível no Hotsite',
        value: 'available_on_hotsite',
      },
      {
        text: '',
        value: 'menu',
        width: 20,
        sortable: false,
      },
    ],
  }),
  computed: {
    query() {
      return LIST_DYNAMIC_ATTRIBUTES
    },
  },
  methods: {
    isDynamicAttributeEditable,
    getTypeLabel(type) {
      const typeObj = DYNAMIC_ATTRIBUTE_TYPES.find((t) => t.key === type)
      return typeObj ? typeObj.label : type
    },
    getOriginLabel(origin) {
      const originObj = DYNAMIC_ATTRIBUTE_ORIGINS.find((o) => o.key === origin)
      return originObj ? originObj.label : origin
    },
    goToDynamicAttribute(dynamicAttribute) {
      this.$refs.editDialog.open(dynamicAttribute)
    },
    async saveDynamicAttribute(data) {
      await this.$apollo.mutate({
        mutation: UPSERT_DYNAMIC_ATTRIBUTE,
        variables: { attribute: data },
      })
      this.$refs.table.waitAndGetData()
    },
  },
}
</script>
